// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Only what the dashboard adds to the shared top bar
   (GlobalPageHeader.module.css). */

/* The page is laid out under a bar that floats over it, like the canvas. */
.VfLskpF9W_shWxvAIzlG {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
}

/* The dashboard has no room under the bar for a page title, so its name sits
   in the bar, first after the logo. */
.Zk9gsu40yf3IK1EhCJnz {
  flex: 0 1 auto;
  min-width: 0;
  max-width: 420px;
  margin: 0 12px 0 4px;
  color: var(--curio-text-on-dark);
  font-family: inherit;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/DashboardTopBar.module.css"],"names":[],"mappings":"AAAA;mCACmC;;AAEnC,2EAA2E;AAC3E;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;sCACsC;AACtC;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;EAChC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB","sourcesContent":["/* Only what the dashboard adds to the shared top bar\n   (GlobalPageHeader.module.css). */\n\n/* The page is laid out under a bar that floats over it, like the canvas. */\n.bar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 100;\n}\n\n/* The dashboard has no room under the bar for a page title, so its name sits\n   in the bar, first after the logo. */\n.title {\n  flex: 0 1 auto;\n  min-width: 0;\n  max-width: 420px;\n  margin: 0 12px 0 4px;\n  color: var(--curio-text-on-dark);\n  font-family: inherit;\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bar": `VfLskpF9W_shWxvAIzlG`,
	"title": `Zk9gsu40yf3IK1EhCJnz`
};
export default ___CSS_LOADER_EXPORT___;
